import React, { useContext, useState } from "react";
import { debug } from "../../utils";
import { connect } from "react-redux";
import { CheckboxTable } from "../../view/CheckboxTable";
import { useAnalysisTableHelper } from "./useAnalysisTableHelper";
import AnalysisTableRow from "./AnalysisTableRow";
import AnalysisTableRowSkeleton from "./AnalysisTableRowSkeleton";
import { TableContext } from "../../index";
import ValidateHeaderMenuItem from "../validate/ValidateHeaderMenuItem";

function AnalysisTable({ validationResultList }) {

    const helper = useAnalysisTableHelper();
    const { config } = useContext(TableContext);

    const dataColumns = [
        { name: 'NOTES', state: true },
        { name: 'RULE NAME', state: true, sortKey: 'rule', onClick: () => helper.onRuleNameClick() },
        { name: 'DESCRIPTION', state: true, sortKey: 'details', onClick: () => helper.onDetailsClick() },
        { name: 'COMPLIANCE', state: false },
        { name: 'SECTION', state: false, sortKey: 'sectionName', onClick: () => helper.onSectionClick() },
        { name: 'SUBSECTION', state: false, sortKey: 'subsectionName', onClick: () => helper.onSubsectionClick() },
        //{name: 'EXPECTED RESULT', onClick: () => helper.onExpectedResultClick()},
        { name: 'CREATED BY', state: false, sortKey: 'user', onClick: () => helper.onUserClick() },
        { name: 'SEVERITY', state: true, sortKey: 'severity', onClick: () => helper.onSeverityClick() },
        { name: 'VALID', state: true, sortKey: 'valid', onClick: () => helper.onValidClick() },
        { name: 'GROUP', state: true, onClick: () => helper.onGroupClick() },
    ]

    let [hiddenHeaders, setHiddenHeaders] = useState(
        dataColumns.filter(column => column.state !== true).map(column => column.name)
    );
    let [updatedColumns, setUpdatedColumns] = useState(dataColumns);

    const columnMenu = [{
        name: <ValidateHeaderMenuItem
            updatedHiddenHeaders={hiddenHeaders}
            sendHiddenHeaders={(nextHiddenHeaders) => setHiddenHeaders([...nextHiddenHeaders])}
            dataColumns={updatedColumns}
            sendUpdatedDataColumns={(nextColumns) => setUpdatedColumns(nextColumns)}
        />
    }];

    const headers = [
        ...updatedColumns.filter(column => column.state === true),
        ...columnMenu
    ];

    // Client-side search filtering
    const searchTerm = (config.searchTerm || '').toLowerCase();
    const filteredList = searchTerm
        ? validationResultList.filter(item => {
            const rule = (item.rule || '').toLowerCase();
            const details = (item.details || '').toLowerCase();
            const compliance = (item.compliance || '').toLowerCase();
            const sectionName = (item.sectionName || '').toLowerCase();
            const subsectionName = (item.subsectionName || '').toLowerCase();
            const user = (item.user || '').toLowerCase();
            const severity = (item.severity || '').toLowerCase();
            const note = (item.note || '').toLowerCase();
            return rule.includes(searchTerm) || details.includes(searchTerm) ||
                compliance.includes(searchTerm) || sectionName.includes(searchTerm) ||
                subsectionName.includes(searchTerm) || user.includes(searchTerm) ||
                severity.includes(searchTerm) || note.includes(searchTerm);
        })
        : validationResultList;

    return (
        <>
            <CheckboxTable headers={headers} elements={filteredList} containsEditButton={false}>
                {config.isLoading ? (
                    Array.from(new Array(10)).map((_, index) => (
                        <AnalysisTableRowSkeleton key={index} index={index} hiddenHeaders={hiddenHeaders} />
                    ))
                ) : (
                    filteredList.map((data, index) => <AnalysisTableRow key={index} data={data} index={index} hiddenHeaders={hiddenHeaders} />)
                )}
            </CheckboxTable>
            {!config.isLoading && filteredList.length === 0 && (
                <div className="oct_empty-state-v2">
                    <div className="oct_empty-state-title">No records found</div>
                    <div>Try adjusting your search or filters to find what you're looking for.</div>
                </div>
            )}
        </>
    );
}

function mapStateToProps(state) {
    debug("AnalysisTable mapStateToProps", state);
    const analysisPage = state.analysisPage;
    return {
        validationResultList: analysisPage.validationResultList || []
    };
}

export default connect(mapStateToProps)(AnalysisTable);
